var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 marker-details"},[_c('h3',[_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.$t('individual_records')))]),_vm._v(" "),_c('Menu')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }